import React from 'react';

// Loading placeholder that mirrors PassportCover (dark header, CV thumb on the
// left + stations rows on the right, footer). Kept intentionally minimal so it
// matches the in-card loading state (only stations stream in afterwards) and
// avoids reflow when the real card mounts. Used in feed/search result grids.
const PassportCoverSkeleton: React.FC = () => (
  <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden flex flex-col">
    {/* Dark header band */}
    <div className="px-3.5 py-2 bg-slate-900 flex items-center justify-between">
      <div className="flex items-center gap-1.5">
        <div className="w-3 h-3 rounded-full bg-white/20 animate-pulse" />
        <div className="h-2 w-12 bg-white/15 rounded animate-pulse" />
      </div>
      <div className="h-3.5 w-10 rounded-full bg-white/15 animate-pulse" />
    </div>

    {/* Body — CV thumb (left) + stations (right) */}
    <div className="p-4 relative overflow-hidden">
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/50 to-transparent z-10" />

      <div className="flex items-start gap-3">
        <div className="w-16 flex-shrink-0 aspect-[3/4] rounded-lg bg-slate-100 border border-slate-200 animate-pulse" />
        <div className="flex-1 min-w-0 space-y-2.5">
          {[0, 1, 2].map((i) => (
            <div key={i} className="flex items-center gap-2.5" style={{ opacity: 1 - i * 0.18 }}>
              <div className="w-6 h-6 rounded-full bg-pink-50 animate-pulse flex-shrink-0" />
              <div className="h-3 flex-1 bg-slate-200/70 rounded animate-pulse" />
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Footer */}
    <div className="px-4 py-2.5 border-t border-slate-100 flex items-center justify-between">
      <div className="h-2.5 w-12 bg-slate-200/60 rounded animate-pulse" />
      <div className="h-2.5 w-20 bg-pink-100 rounded animate-pulse" />
    </div>
  </div>
);

export default PassportCoverSkeleton;
